export default {"src":"/_next/static/media/shield-lock-icon.51bec392.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};